import store from '@/store'
import { MessageBox } from 'element-ui'
import moment from 'moment'

let watermarkDiv = null
const watermarkId = 'watermark-div'
let isUpdating = false

export const addWatermark = (text, color = 'rgba(0, 0, 0, 0.1)') => {
  isUpdating = true
  removeWatermark()

  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const fontSize = 16
  canvas.width = 300
  canvas.height = 150

  if (ctx) {
    ctx.font = `${fontSize}px Arial`
    ctx.fillStyle = color
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.translate(canvas.width / 2, canvas.height / 2)
    ctx.rotate(-Math.PI / 6)
    ctx.fillText(text, 0, 0)
  }

  const base64Url = canvas.toDataURL('image/png')
  watermarkDiv = document.createElement('div')
  watermarkDiv.id = watermarkId
  watermarkDiv.style.position = 'fixed'
  watermarkDiv.style.pointerEvents = 'none'
  watermarkDiv.style.top = '0'
  watermarkDiv.style.left = '0'
  watermarkDiv.style.width = '100vw'
  watermarkDiv.style.height = '100vh'
  watermarkDiv.style.backgroundImage = `url(${base64Url})`
  watermarkDiv.style.backgroundRepeat = 'repeat'
  watermarkDiv.style.zIndex = '99999'
  watermarkDiv.style.userSelect = 'none'
  watermarkDiv.style.display = 'block'

  try {
    document.body.appendChild(watermarkDiv)
    console.log('水印元素已添加到DOM')
  } catch (e) {
    console.error('添加水印失败:', e)
  }

  setTimeout(() => {
    isUpdating = false
  }, 100)
}

export const removeWatermark = () => {
  isUpdating = true
  if (watermarkDiv) {
    try {
      if (watermarkDiv.parentNode) {
        watermarkDiv.parentNode.removeChild(watermarkDiv)
      }
      watermarkDiv = null
    } catch (e) {
      console.error('移除水印失败:', e)
    }
  }
  setTimeout(() => {
    isUpdating = false
  }, 100)
}

export const initWatermark = () => {
  const token = store.getters.token
  if (!token) {
    return
  }
  const globalWatermarkEnabled = true
  const watermarkTextColor = 'rgba(0, 0, 0, 0.1)'
  const user = store.getters.user || {}
  const userName = user.name || '未知用户'
  if (globalWatermarkEnabled) {
    const time = moment().format('YYYY-MM-DD')
    const watermarkText = `${userName} ${time}`
    addWatermark(watermarkText, watermarkTextColor)
  }

  const observer = new MutationObserver((mutations) => {
    if (!store.getters.token) {
      return
    }

    const wmInstance = document.getElementById(watermarkId)
    const globalWatermarkEnabled = true
    let watermarkRemoved = false
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && !isUpdating) {
        for (let i = 0; i < mutation.removedNodes.length; i++) {
          const node = mutation.removedNodes[i]
          if (node instanceof HTMLElement && node.id === watermarkId) {
            watermarkRemoved = true
            break
          }
        }
        if (watermarkRemoved) break
      }
    }

    if (watermarkRemoved) {
      const time = moment().format('YYYY-MM-DD')
      const userInfo = store.getters.user || {}
      const name = userInfo.realName || '未知用户'
      const watermarkText = `${name} ${time}`
      addWatermark(watermarkText, store.state.settings.watermarkTextColor || 'rgba(0, 0, 0, 0.1)')
      MessageBox.alert('禁止删除水印，已记录此行为！', '系统提示', {
        confirmButtonText: '我知道了',
        confirmButtonClass: 'el-button--small',
        type: 'warning',
        autofocus: false
      })
      return
    }
    if (!wmInstance && globalWatermarkEnabled) {
      const time = moment().format('YYYY-MM-DD')
      const userInfo = store.getters.user || {}
      const name = userInfo.realName || '未知用户'
      const watermarkText = `${name} ${time}`
      addWatermark(watermarkText, store.state.settings.watermarkTextColor || 'rgba(0, 0, 0, 0.1)')
    } else if (wmInstance && !globalWatermarkEnabled) {
      removeWatermark()
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'id']
  })

  store.watch(
    (state) => state.user.token,
    (newValue) => {
      if (newValue && store.state.settings.Watermark) {
        const time = moment().format('YYYY-MM-DD')
        const user = store.getters.user || {}
        const name = user.realName || '未知用户'
        const watermarkText = `${name} ${time}`
        addWatermark(watermarkText, store.state.settings.watermarkTextColor)
      } else {
        removeWatermark()
      }
    }
  )
}
export const forceAddWatermark = () => {
  try {
    if (!store.getters.token) {
      return
    }

    const user = store.getters.user || {}
    const userName = user.realName || '未知用户'
    const time = moment().format('YYYY-MM-DD')
    const watermarkText = `${userName} ${time}`
    const color = 'rgba(0, 0, 0, 0.1)'

    addWatermark(watermarkText, color)
  } catch (e) {
    console.error('添加水印失败:', e)
  }
}

export const watermarkDirective = {
  bind (el) {
    setTimeout(() => {
      if (store.getters.token) {
        forceAddWatermark()
      }
    }, 200)
  }
}
